import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeBottom12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconEdgeBottom12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.235 4.54a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-.75 1.475a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-.5 5.17a.5.5 0 1 0 0-1h-6a.5.5 0 0 0 0 1zm-1.5-9.62a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-1.5.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-3-.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-1.25 5.2a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m7.75 1.475a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-7.75.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-.75-5.2a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeBottom12);
